import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { homeForRole, isStaffRole } from "../lib/authApi";
import { Logo } from "./Logo";
import { ContactOffice } from "./ContactOffice";
import ForceChangePassword from "./ForceChangePassword";

export const FullPageLoader = () => (
  <div data-testid="page-loader" className="rmm-bg min-h-screen flex flex-col items-center justify-center gap-6">
    <Logo linkTo={null} />
    <Loader2 className="h-8 w-8 animate-spin text-[#7A0016]" />
  </div>
);

export function RequireClient({ children }) {
  const { session, role, loading, isActive } = useAuth();
  const loc = useLocation();
  if (loading) return <FullPageLoader />;
  if (!session) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (isStaffRole(role)) return <Navigate to="/admin" replace />;
  if (!isActive) return <ContactOffice />;
  return children;
}

export function RequireStaff({ children }) {
  const { session, role, loading, isActive } = useAuth();
  if (loading) return <FullPageLoader />;
  if (!session) return <Navigate to="/admin/login" replace />;
  if (!isStaffRole(role)) return <Navigate to="/portal" replace />;
  if (!isActive) return <ContactOffice />;
  if (session.user?.app_metadata?.must_change_password) return <ForceChangePassword />;
  return children;
}

export function useRedirectIfAuthed() {
  const { session, role, loading } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (!loading && session && role) navigate(homeForRole(role), { replace: true });
  }, [loading, session, role, navigate]);
}
